import { React, useState } from "react";
import { Link } from "react-router-dom";
import "./NavBar.scss";

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="NavBar">
      <div className="NavBar-container">
        <div className="NavBar-container_logo">
          <Link className="NavBar-container_menu--items__txt" to={"/"}>
            <img className="NavBar-container_logo--img" src="navBar/logo.png" />
          </Link>
        </div>
        <div className="NavBar-container_title">
          <h1 className="NavBar-container_title--txt">
            Importacion
            <br /> FyA
          </h1>
        </div>
        <div className="NavBar-container_menu">
          <button
            className="NavBar-container_menu--button"
            onClick={toggleMenu}
          >
            <img
              className="NavBar-container_menu--button__img"
              src="navBar/menu.png"
            />
          </button>

          <div
            className={`NavBar-container_menu--items ${isOpen ? "open" : ""}`}
          >
            <Link
              className="NavBar-container_menu--items__txt"
              to={"/"}
              onClick={toggleMenu}
            >
              Home
            </Link>
            <Link
              className="NavBar-container_menu--items__txt"
              to={"/iPhone"}
              onClick={toggleMenu}
            >
              IPhone
            </Link>
            <Link
              className="NavBar-container_menu--items__txt"
              to={"/Mac"}
              onClick={toggleMenu}
            >
              Mac
            </Link>
            <Link
              className="NavBar-container_menu--items__txt"
              to={"/Accesories"}
              onClick={toggleMenu}
            >
              Accesorios
            </Link>
            <Link
              className="NavBar-container_menu--items__txt"
              to={"/AboutUs"}
              onClick={toggleMenu}
            >
              Nosotros
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavBar;
